import AbstractEntity from "../AbstractEntity";

export default class Order extends AbstractEntity {
    static STATUS_IN_PROGRESS = 0;
    static STATUS_COMPLETED = 1;
    static STATUS_CHECKED = 2;
    static STATUS_CANCELLED = 3;

    static END_REASON_QUOTATION_REFUSED = 0;
    static END_REASON_BENEFICIARY_NOT_REPLY = 1;

    _id;
    _externalId;
    _workId;
    _orderComment;
    _status;
    _endReason;
    _adminId;
    _createdAt;
    _clientId;
    _interventionId;
    _addressId;
    _internalCommentsId;
    _emergencyInterventionDocumentId;


    getId() {
        return this._id;
    }

    getExternalId() {
        return this._externalId;
    }

    getWorkId() {
        return this._workId;
    }

    getOrderComment() {
        return this._orderComment;
    }

    getStatus() {
        return this._status;
    }

    getEndReason() {
        return this._endReason;
    }

    getAdminId() {
        return this._adminId;
    }

    getCreatedAt() {
        return this._createdAt;
    }

    getClientId() {
        return this._clientId;
    }

    getInterventionId() {
        return this._interventionId;
    }

    getAddressId() {
        return this._addressId;
    }

    getInternalCommentsId() {
        return this._internalCommentsId;
    }

    getEmergencyInterventionDocumentId() {
        return this._emergencyInterventionDocumentId;
    }

    getClassName() {
        return "order";
    }
}